module.exports = __webpack_public_path__ + "static/media/white-logo.174f29af.svg";